module.exports = {
      id: "resize-icon-usage",
      viewBox: "0 0 6 14",
      url: __webpack_public_path__ + "sprite-dbc6d5.smartcharts.svg#resize-icon-usage",
      toString: function () {
        return this.url;
      }
    }